import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { useI18n } from '../../i18n/index.js'
import { GenericOperatorPicker } from '../components/GenericOperatorPicker.js'
import { ListFilterByOperator, type OperatorPickerComponent } from '../types.js'
import { getOperatorName } from '../utils/operators.js'

export const textOperators: ListFilterByOperator[] = [
  ListFilterByOperator.contains,
  ListFilterByOperator.equals,
  ListFilterByOperator.not,
  ListFilterByOperator.startsWith,
  ListFilterByOperator.endsWith,
]

export const TextOperatorPicker: OperatorPickerComponent = ({
  filter,
  onChange,
}) => {
  const intl = useI18n()
  const { operator, type, subType, value } = filter
  const currentOperatorName = getOperatorName(
    operator,
    type,
    subType,
    value,
    intl,
  )

  return (
    <GenericOperatorPicker operatorName={currentOperatorName}>
      {textOperators.map(operator => (
        <Dropdown.Item key={operator} onClick={() => onChange(operator)}>
          {getOperatorName(operator, type, subType, value, intl)}
        </Dropdown.Item>
      ))}
    </GenericOperatorPicker>
  )
}
